export const SET_TABS = 'SET.TABS';
export const SET_ACTIVE_TAB = 'SET.ACTIVE.TAB';
export const SET_LOADED_TAB = 'SET.LOADED.TAB';
export const SET_SORTS = 'SET.SORTS';
export const SET_LOAD_MORE = 'SET.LOAD.MORE';
export const SET_SEARCH_TYPE = 'SET.SEARCH.TYPE';
export const SET_SEARCH_TERM = 'SET.SEARCH.TERM';
export const SET_POPSTATE = 'SET.POPSTATE';

// products
export const SET_FIRST_QUERY = 'SET.FIRST.QUERY';
export const SET_FILTERS = 'SET.FILTERS';
export const APPLY_FILTER = 'APPLY.FILTER';
export const APPLY_SORT = 'APPLY.SORT';
export const CLEAR_FILTERS = 'CLEAR.FILTERS';
